import { Component, OnInit } from '@angular/core';
import {LoadsService} from "../../../services/loads/loads.service";
import {StockInventoryModel} from "../../../models/loads/stock-inventory.model";
import {BaseFormComponentComponent} from "../../../shared/base-form-component/base-form-component.component";
import {Injector} from "@angular/core";
import * as moment from "moment";
import {Workbook} from 'exceljs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-stcok-inventory',
  templateUrl: './stock-inventory.component.html',
  styleUrls: ['./stock-inventory.component.scss']
})
export class StockInventoryComponent extends  BaseFormComponentComponent implements OnInit {

  stockInventroies: StockInventoryModel[] = [];

  startDate: Date;
  endDate: Date;
  imageDisplay = false;
  photoData: any;

  constructor(private loadsService: LoadsService, protected injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    const date = new Date();
    this.startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.getStockInventory();
  }

  getStockInventory() {
    this.isLoading = true;

    this.loadsService.getStockInventory( this.startDate ? moment(this.startDate, 'MM-DD-YYYY').utc().format("YYYY-MM-DDT00:00:00.000") : null, this.endDate ?  moment(this.endDate, 'MM-DD-YYYY').utc().format("YYYY-MM-DDT23:59:59.999") : null).subscribe(r => {
      this.stockInventroies = r;
      this.isLoading = false;
      console.log(this.stockInventroies, "asd")
    })
  }

    showImage(photoData) {
        if (photoData) {
            this.photoData = photoData;
            this.imageDisplay = true;
        }
    }

    async exportExcel() {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Stok Envanter');

        worksheet.columns = [
            { header: 'Tarih',            key: 'date',       width: 15 },
            { header: 'Üretici',          key: 'customer',   width: 30 },
            { header: 'Adres Kategorisi', key: 'category',   width: 20 },
            { header: 'Resim',            key: 'photo',      width: 18 },
            { header: 'Ürün Kodu',        key: 'code',       width: 15 },
            { header: 'Ürün Adı',         key: 'name',       width: 30 },
            { header: 'Giriş Miktar',     key: 'inQty',      width: 15 },
            { header: 'Kalan Miktar',     key: 'remainQty',  width: 15 },
        ];

        for (let i = 0; i < this.stockInventroies.length; i++) {
            const inventory = this.stockInventroies[i];
            const row = worksheet.addRow({
                date:      inventory.receiveDate ? moment(inventory.receiveDate).format('DD.MM.YYYY') : '',
                customer:  inventory.customer?.name,
                category:  '',
                photo:     '',
                code:      inventory.whProductCode,
                name:      inventory.whProduct?.name,
                inQty:     inventory.inQuantity,
                remainQty: inventory.remainingQuantity,
            });
            row.height = 80;

            if (inventory.photo) {
                // photo data:image/png;base64,... şeklinde geliyorsa:
                const base64 = String(inventory.photo).includes(',')
                    ? String(inventory.photo).split(',')[1]
                    : String(inventory.photo);

                const extension: 'png' | 'jpeg' = String(inventory.photo).toLowerCase().includes('jpeg') || String(inventory.photo).toLowerCase().includes('jpg')
                    ? 'jpeg'
                    : 'png';

                const imageId = workbook.addImage({
                    base64,
                    extension,
                });

                // Excel satır numarası: header 1. satır, veri 2. satırdan başlıyor
                const excelRow = i + 1; // 0-indexed; D sütunu = col index 3
                worksheet.addImage(imageId, {
                    tl: { col: 3, row: excelRow },
                    ext: { width: 100, height: 100 },
                });
            }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'stok_envanter_resimli.xlsx');
    }

}
